import { defineComponent as _defineComponent } from 'vue'

import { watchDebounced } from '@vueuse/core';
import { computed, watch, ref } from '@nuxtjs/composition-api';
import useDPD from '@/composables/useDPD';
import useUPS from '@/composables/useUPS';

interface Props {
  formData: any;
}
interface Emits {
  (e: 'ups-locations-searched', data: any): void;
}
type ServiceNames = 'dpd' | 'ups';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceFormProvider',
  props: {
    formData: null
  },
  emits: ["ups-locations-searched"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'ups-locations-searched', data: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  formData: any;
};




const DPD_FETCH_CITIES_ERROR_CODE = 1001;

const {
  getDpdCountries,
  dpdCountries,
  getDpdCities,
  dpdCities,
  isDpdCitiesLoading,
} = useDPD();
const {
  generateToken,
  upsCountries,
  locations: upsSuggestions,
  getLocations: getUpsLocations,
  isLocationsLoading: isUpsLocationsLoading,
} = useUPS();

const deliveryAgents: {
  id: ServiceNames;
  name: string;
}[] = [
  {
    id: 'dpd',
    name: 'DPD',
  },
  {
    id: 'ups',
    name: 'UPS',
  },
];

const isDpdAdressesDisabled = ref(false);
const dpdSuggestions = ref<null | any[]>(null);

const availableFormFields = computed(() => {
  if (props.formData.deliveryAgent === 'dpd') return [];
  if (props.formData.deliveryAgent === 'ups')
    return ['street', 'city', 'postalCode', 'state'];
  return [];
});

// Используется в ServiceForm компоненте для того чтобы дизейблить
// поле fullAddress (autocomplete)
const isAddressSelectUnavailable = computed(() => {
  if (props.formData.deliveryAgent === 'dpd')
    return !props.formData.country || isDpdAdressesDisabled.value;
  if (props.formData.deliveryAgent === 'ups')
    return !(props.formData.country && props.formData.postalCode);
  return true;
});

const countriesListForService = computed(() => {
  if (props.formData.deliveryAgent === 'dpd') {
    return dpdCountries.value;
  }
  if (props.formData.deliveryAgent === 'ups') {
    return upsCountries;
  }
  return [];
});
const suggestionsListForService = computed(() =>
  props.formData.deliveryAgent === 'dpd'
    ? dpdSuggestions.value
    : upsSuggestions.value,
);
const isLocationsLoading = computed(() =>
  props.formData.deliveryAgent === 'dpd'
    ? isDpdCitiesLoading.value
    : isUpsLocationsLoading.value,
);

const getDpdCitiesBySelectedCountry = async (countryName: string) => {
  // selectedCountryId всегда будет найден потому как в селекте
  // используется список dpdCountries
  const selectedCountryId = (
    dpdCountries.value as { id: number; name: string }[]
  ).find((dpdCountry) => dpdCountry.name === countryName)!.id;
  console.log('COUNTRY ID', dpdCountries.value, selectedCountryId);
  const citiesData = await getDpdCities(selectedCountryId);
  dpdSuggestions.value = dpdCities.value;
  isDpdAdressesDisabled.value = citiesData.code === DPD_FETCH_CITIES_ERROR_CODE;
};
const setSuggestions = (value?: any[]) => {
  if (props.formData.deliveryAgent === 'dpd')
    dpdSuggestions.value = value ?? dpdCities.value;
};
const getAvailableFormFields = () => availableFormFields.value;
const getLocations = (serviceName: ServiceNames) =>
  serviceName === 'dpd' ? dpdCities.value : upsSuggestions.value;

/*
Выполнение запроса для получения подсказок (suggestions) от UPS
только тогда, когда заполнены поля (country, postalCode) с задержкой в 1.5s
*/
watchDebounced(
  [
    () => props.formData.street,
    () => props.formData.city,
    () => props.formData.postalCode,
    () => props.formData.country,
    () => props.formData.state,
  ],
  () => {
    if (
      props.formData.deliveryAgent === 'ups' &&
      !isAddressSelectUnavailable.value
    ) {
      getUpsLocations({
        addressLine: props.formData.street,
        city: props.formData.city,
        postalCode: props.formData.postalCode,
        country: props.formData.country,
        state: props.formData.state,
      });
      emit('ups-locations-searched', upsSuggestions.value);
    }
  },
  { debounce: 1500 },
);
watch(
  () => props.formData.deliveryAgent,
  async (newVal: 'ups' | 'dpd') => {
    if (newVal === 'ups') await generateToken();
    if (newVal === 'dpd' && !dpdCountries.value.length) {
      await getDpdCountries();
    }
  },
);

expose({
  deliveryAgents,
  setSuggestions,
  getAvailableFormFields,
  getLocations,
  dpd: {
    getDpdCountries,
    dpdCountries,
    dpdCities,
    isDpdCitiesLoading,
    dpdSuggestions,
    getDpdCitiesBySelectedCountry,
  },
  ups: {
    upsCountries,
    upsSuggestions,
    getUpsLocations,
    isUpsLocationsLoading,
  },
  countriesListForService,
});

return { __sfc: true,props, emit, DPD_FETCH_CITIES_ERROR_CODE, getDpdCountries, dpdCountries, getDpdCities, dpdCities, isDpdCitiesLoading, generateToken, upsCountries, upsSuggestions, getUpsLocations, isUpsLocationsLoading, deliveryAgents, isDpdAdressesDisabled, dpdSuggestions, availableFormFields, isAddressSelectUnavailable, countriesListForService, suggestionsListForService, isLocationsLoading, getDpdCitiesBySelectedCountry, setSuggestions, getAvailableFormFields, getLocations }
}

})